module.exports = __webpack_public_path__ + "static/media/neutral_neutral.4cf81b0a.svg";